export default {
  data() {
    return {
      setProducts: [],
      fullscreen: false,
      productView: false,
    };
  },
  computed: {
    photosView() {
      return this.$store.getters.REPLACED_PHOTO_DATA;
    },
  },
  methods: {
    viewProduct(product) {
      this.productView = product;
    }
  },
  async created() {
    if (!this.uuid) {
      const set = await this.$store.dispatch('INIT_SET_MATCH',
          {set_id: this.set.id, album: this.album});
      this.setProducts = set ? set.products : [];
    } else {
      this.setProducts = this.set.products;
    }
  },
  mounted() {
    document.onkeydown = evt => {
      evt = evt || window.event;

      if (evt.keyCode === 27) {
        this.closeOrderSet();
        this.$store.dispatch('SET_DRAWING', null);
      } else if (evt.keyCode === 13) {
        const nextBtn = document.getElementById('nextBtn');

        if (nextBtn) {
          nextBtn.click();
        }
      }
    };

    window.onhashchange = () => {
      if (this.photosView) {
        this.$store.dispatch('SET_REPLACED_PHOTO_PRODUCT', false);
      } else {
        this.closeOrderSet();
      }
    };

    window.addEventListener('resize', () => {
      this.$store.dispatch('SET_DRAWING', null);
    });
  },
};
